export const CodeBookItemFragment = gql`
  fragment CodeBookItemFragment on CodeBookItem {
    id
    formattedName
    fullyQualifiedFormattedName
    section
    title
    text
  }
`

export const CodeBookItemEditorFragment = gql`
  fragment CodeBookItemEditorFragment on CodeBookItem {
    ...CodeBookItemFragment
    chapter {
      ...CodeBookChapterFragment
    }
  }
`

export const CodeBookItemSearchResultFragment = gql`
  fragment CodeBookItemSearchResultFragment on CodeBookItemSearchResult {
    bodyTextSnippetHtml
    item {
      ...CodeBookItemEditorFragment
    }
  }
`

export const CodeBookItemOptionFragment = gql`
  fragment CodeBookItemOptionFragment on CodeBookItem {
    ...CodeBookItemFragment
    codeBook {
      id
      name
    }
  }
`
